module.exports = __webpack_public_path__ + "img/lampIcon.2835e4da.svg";